




import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class Gravatar extends Vue {
  @Prop(String) gravatar: string;

  get imgUrl() {
    if (this.gravatar == "") {
      return "";
    } else {
      return "https://www.gravatar.com/avatar/" + this.gravatar + "?d=retro";
    }
  }
}
